import { Injectable, ɵConsole } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import { forkJoin, Observable } from 'rxjs';


const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});


@Injectable()
export class CustomerService {


  customerUrl = '/superadmin/rest/mgmt/consumer?';
  countUrl = '/superadmin/rest/mgmt/consumer/count?';
  consumerAnalyticsUrl = '/superadmin/rest/mgmt/analytics/consumers';
  consumerAnalyticsCountUrl = '/superadmin/rest/mgmt/analytics/consumers/count?';
  consumerStatusUrl = '/superadmin/rest/mgmt/consumer/toggleStatus';
  consumerPhoneUrl = '/superadmin/rest/mgmt/consumer/changePhone';
  customerDetailsUrl = '/superadmin/rest/mgmt/consumer';
  customerDeleteUrl = '/superadmin/rest/mgmt/consumer?id=';
  customerMarkUrl = '/superadmin/rest/mgmt/consumer/prod';
  consumerData: any = {};
  dataObj: any = {};
  userAgentFilter: any;
  consumerCatFilter: any;
  customerOfferUrl = '/superadmin/rest/mgmt/jcash/offer/stat';
  issueJcashUrl = '/superadmin/rest/mgmt/jcash';
  kamUrl = '/superadmin/rest/mgmt/spdataexport/account/kam/export';
  constructor(private http: HttpClient) { }

  getCustomers(
    filter, sortOrder,
    pageNumber, pageSize = 10):  Observable<any> {

    return this.http.get(this.customerUrl + filter,
      {
        params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
    });
}
getCustomersFromOffer(
  filter, sortOrder,
  pageNumber, pageSize = 10):  Observable<any> {

  return this.http.get(this.customerOfferUrl + '/' + filter,
    {
      params: new HttpParams()
          .set('asc', sortOrder)
          .set('from', pageNumber.toString())
          .set('count', pageSize.toString())
  });
}
// Get total count of audits
getCount(): Observable<any> {
  return this.http.get(this.countUrl, {headers});
}

getTotalFilterCount(filter): Observable<any> {
  return this.http.get(this.countUrl + filter, {headers});
}

getConsumerAnalytics(filterparams): Observable<any> {
  return this.http.get(this.consumerAnalyticsUrl + filterparams, { headers: headers });
}
getCustomerWebAndMobCount(filter): Observable<any> {
  const ios = this.http.get(this.consumerAnalyticsCountUrl + filter + '&userAgent=IOS', {headers});
  const android = this.http.get(this.consumerAnalyticsCountUrl + filter + '&userAgent=ANDROID', {headers});
  const web = this.http.get(this.consumerAnalyticsCountUrl + filter + '&userAgent=BROWSER', {headers});

  return forkJoin([ios, android, web]);
//  .map(responses => {
//     return [].concat(...responses);
//  });
}

changeStatus(consumerId): Observable<any> {
  return this.http.put(this.consumerStatusUrl + '/' + consumerId, {headers});
}
// changePhoneno(data):Observable<any> {
//   console.log(data);
//   return this.http.put(this.consumerPhoneUrl, data, { headers: headers });
// }
changePhoneno(data): Observable<any> {
  console.log(data);
  return this.http.put(this.consumerPhoneUrl, data, { headers: headers });
}
deleteCustomer(consumerId): Observable<any> {
  return this.http.delete(this.customerDeleteUrl + consumerId, {headers});
}
markCustomer(consumerId,status): Observable<any> {
  return this.http.put(this.customerMarkUrl + '/' + consumerId + '/' + status, {headers});
}
getDetails(id): Observable<any> {
  return this.http.get(this.customerDetailsUrl + '/' + id, {headers});
}

issueJaldeeCash(data) {
  return this.http.post(this.issueJcashUrl, data, {headers: headers });
}
storeConsumerData(data) {
  this.consumerData = {};
  this.consumerData = data;

}
retriveConsumerData() {
  return this.consumerData;
}
 setUserAgentFilterParam(data) {
   this.userAgentFilter = data;
 }

 getUserAgentFilterParam() {
  return this.userAgentFilter;
}
setConsumerCategory(data) {
  this.consumerCatFilter = data;
}
getConsumerCategory() {
  return this.consumerCatFilter;
}
generatrKAMreport(data) {
  return this.http.put(this.kamUrl, data, {headers: headers });
}
}
